export default __webpack_public_path__ + "static/media/missing.bb1790e0.svg";